import { DATE_SHORT_FORMAT } from '../../../../constants/date'
import { getViewingTimeRangeLabel } from '../../../RentalPortalViewing'
import { formatDate } from '../../../Table'

export function getViewingRescheduleHistoryLabel({ item, locale, timezone }) {
  const dateLabel = formatDate({
    date: item.start,
    dateFormat: DATE_SHORT_FORMAT,
    locale,
    timezone,
    useTodayFormat: false,
  })

  const timeLabel = getViewingTimeRangeLabel({
    end: item.end,
    locale,
    start: item.start,
    timezone,
  })

  return `${dateLabel} · ${timeLabel}`
}
